import React from "react";

export default function LangToggle({ lang, setLang }) {
  return (
    <div className="inline-flex rounded-full border border-white/15 bg-white/5 overflow-hidden text-[11px] font-bold uppercase tracking-wider shrink-0" data-testid="lang-toggle">
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        className={`px-3 py-1.5 transition-colors ${lang === "en" ? "bg-orange-500/90 text-white" : "text-slate-300 hover:text-white"}`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang("bn")}
        data-testid="lang-bn"
        className={`px-3 py-1.5 transition-colors font-bn ${lang === "bn" ? "bg-orange-500/90 text-white" : "text-slate-300 hover:text-white"}`}
      >
        বাংলা
      </button>
    </div>
  );
}
